import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import BootstrapModal from "designs/v1/pages/ModifyKyc/components/BootstrapModal";
import {
  getNomineeReviewApi,
  submitNomineeReviewApi,
  nomineeRequestForEsign,
  getNomineeStageApi,
} from "designs/v1/pages/ModifyKyc/services";

const NomineeModificationReview = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
}) => {
  const history = useHistory();
  const [reviewData, setReviewData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("NomineeRequestNumber"),
    };
    const loadReview = async () => {
      try {
        const resp = await getNomineeReviewApi(payload);
        setReviewData(resp.data?.data);
        console.log("resp", resp);
      } catch (error) {
        console.log("err", error);
      }
    };
    loadReview();
    return () => {
      // localStorage.removeItem("NomineeRequestNumber");
    };
  }, []);

  const handleShowHideModal = () => {
    setShowModal((bool) => !bool);
  };
  const handleSubmit = async () => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("NomineeRequestNumber"),
    };
    console.log("payload", payload);
    setShowModal(false);
    setIsLoading(true);
    try {
      const resp = await submitNomineeReviewApi(payload);
      console.log("resp", resp);
      try {
        const esignResp = await nomineeRequestForEsign(payload);
        setIsLoading(false);
        if (esignResp.data.message?.status_code !== 200) {
          return toast.error(
            resp.esignResp.message?.message || "Internal server error!"
          );
        }
        if (resp.data.message?.status_code !== 200) {
          return toast.error(
            resp.data.message?.message || "Internal server error!"
          );
        }
        toast.success(resp.data.message?.message);
        setStep("NomineeModificationESignature");
      } catch (error) {
        const { data } = error.response || {};
        toast.error(data.message?.message || "Internal server error!");
        setIsLoading(false);
      }
    } catch (error) {
      console.log("err", error);
      setIsLoading(false);
      const { data } = error.response || {};
      toast.error(data.message?.message || "Internal server error!");
    }
  };

  return (
    <>
      <Title title="Review Details" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              {reviewData && (
                <div>
                  <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Request Type</h6>
                      <div className="col-sm">{reviewData?.request_type}</div>
                    </div>
                  </div>
                  <div className="row my-4">
                    <h6 className="text-bold m-0">User Details</h6>
                    <div className="row mt-1">
                      <div className="col-sm">Full Name</div>
                      <div className="col-sm">
                        {reviewData.active_user_details?.full_name}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">Mobile Number</div>
                      <div className="col-sm">
                        {reviewData.active_user_details?.mobile?.slice(2)}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">Email Address</div>
                      <div className="col-sm">
                        {reviewData.active_user_details?.email}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">PAN Number</div>
                      <div className="col-sm">
                        {reviewData.active_user_details?.pan_number}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Reason Details</h6>
                      <div className="col-sm">
                        {reviewData.reason_details?.user_input_reason}
                      </div>
                    </div>
                  </div> */}
                  <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Request Number</h6>
                      <div className="col-sm">
                        {reviewData.rekyc_nominee_modi_request_name}
                      </div>
                    </div>
                  </div>
                  <div className="row my-4">
                    {reviewData?.modification_details?.length > 0 ? (
                      <div className="row">
                        <h6 className="text-bold m-0">New Nominee Details:</h6>
                        {/* <div className="row">
                          <h6 className="col-sm">New Nominee Details</h6>
                        </div> */}
                        <table className="table mx-2 mt-2">
                          <thead>
                            <tr>
                              {/* <th scope="col">Sr.no</th> */}
                              <th scope="col">Name</th>
                              <th scope="col">Mobile Number</th>
                              <th scope="col">Date of birth</th>
                              <th scope="col">Relationship</th>
                              <th scope="col">Share(%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {reviewData.modification_details.map((item) => {
                              return (
                                <tr key={item.idx}>
                                  {/* <th scope="row">{index + 1}</th> */}
                                  <td>{item.nominee_name}</td>
                                  <td>{item.mobile}</td>
                                  <td>
                                    {item.nominee_dob?.split("-").reverse().join("-")}
                                  </td>
                                  <td>{item.relationship_with_applicant}</td>
                                  <td>{item.share_of__nominee}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <h6 className="text-bold m-0">No Nominee Details Found...</h6>
                    )}
                  </div>
                  <div className="form-group my-4">
                    <Button
                      title="Submit"
                      type="button"
                      handleClick={handleShowHideModal}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <BootstrapModal
        show={showModal}
        title="Modify Nominee"
        content={"Are you sure you want to modify this Nominee?"}
        loading={isLoading}
        handleClose={handleShowHideModal}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default NomineeModificationReview;
